export const getValidationErrorTypes = (validationErrors) => {
  const result = validationErrors?.map(({ errorInfo }) =>
    Object.entries(errorInfo)?.map(([key, value]) => value),
  );
  return result ? [...new Set(result?.flat(1))] : [];
};
